import React, { useEffect } from "react";

import { useState } from "react";
import { Button } from "../../components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../../components/ui/card";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Textarea } from "../../components/ui/textarea";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../components/ui/select";
import { RadioGroup, RadioGroupItem } from "../../components/ui/radio-group";
import { Checkbox } from "../../components/ui/checkbox";
import { Badge } from "../../components/ui/badge";
import { Star } from "lucide-react";
import PropTypes from "prop-types";
import "../../components/form-renderer.css";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { Alert, Snackbar } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";

export default function FillForm() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  let { id } = useParams();
  const formIDAndTitle = id;

  id = id.split("--")[0];

  const [errors, setErrors] = useState({});
  const [rating, setRating] = useState({});
  const [submissionData, setSubmissionData] = useState(null);

  const [formData, setFormData] = useState();
  const [form, setForm] = useState();

  const me = async () => {
    const response = await axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/auth/me`,
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
    // console.log("🚀 ~ fetchUsers ~ response:", response);
    return response.data;
  };

  const {
    data: meData,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ["me"], // Unique key for the query
    queryFn: me, // The async function to run
    retry: false,
  });

  useEffect(() => {
    const fetchFormById = async () => {
      // console.log("🚀 ~ FillForm ~ meData:", meData);
      //   if ((viewMode === "fill" || viewMode === "preview") && selectedForm) {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/forms/${id}`, {
          withCredentials: true,
        });
        // console.log("🚀 ~ fetchFormById ~ res:", res.data.data);
        // if (viewMode === "fill") {
        const form = res.data.data;
        // debugger
        setForm(form);
        setFormData(() => {
          const initialData = {};
          //   debugger;
          form.fields?.forEach((field) => {
            if (field.type === "select" && field.id === "field_months") {
              initialData[field.id] = new Date().toLocaleString("default", { month: "long" });
            } else {
              initialData[field.id] = "";
            }
          });
          return initialData;
        });

        try {
          const res = await axios.get(
            `${process.env.REACT_APP_API_URL}/allforms/${form.id}/${meData.user_id}`,
            { withCredentials: true }
          );

          // console.log("Fetched Submission Data:", res.data);

          if (res.data?.data?.submission) {
            const sub = res.data.data.submission;
            setSubmissionData(sub);
            // ✅ Redirect to Edit mode if a submission already exists
            navigate(`/mission-tracker/edit/${form.id}/${meData.user_id}/${sub.submission_id}`);
          } else {
            setSubmissionData(null); // reset when no submission
          }
        } catch (err) {
          console.error("Error fetching submission:", err);
        }
        // } else if (viewMode === "preview") {
        //   setPreviewForm(res.data.data);
        // }
      } catch (err) {
        console.error("Error fetching form by ID:", err);
      }
    };
    // };

    fetchFormById();
  }, [id, meData]);

  const [state, setState] = useState({
    open: false,
    severity: "success",
    vertical: "top",
    horizontal: "right",
    message: "",
  });

  const handleFormSubmission = async (formId, submissionData) => {
    // debugger;
    const payload = {
      form_id: formId,
      title: form.title,
      description: form.description,
      submittedAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
      submitted_by: meData?.user_id,
      district: meData?.district,
      submissions: [submissionData],
    };

    try {
      setLoading(true);
      const res = await axios.post(`${process.env.REACT_APP_API_URL}/submissions/add`, payload, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      });
      // console.log("resres", res);

      if (res.data.status === 200) {
        setState({
          ...state,
          open: true,
          severity: "success",
          message: res.data.message, // ✅ Correct path
        });

        // setViewMode("list");
        // setSelectedForm(null);
        setTimeout(() => {
          if (meData?.role_id === 3) {
            navigate("/tasks-management");
          } else {
            navigate("/form-builder");
          }
        }, 3000);

        // setForms((prevForms) =>
        //   prevForms.map((form) =>
        //     form.id === formId
        //       ? {
        //           ...form,
        //           submissions: [...(form.submissions || []), submissionData],
        //         }
        //       : form
        //   )
        // );
      }
    } catch (err) {
      console.error("❌ Error submitting form:", err);

      if (err.response) {
        setState({
          ...state,
          open: true,
          severity: "error",
          message: err.response.data.message || "Failed to submit form",
        });
      } else {
        setState({
          ...state,
          open: true,
          severity: "error",
          message: "Server error. Please try again.",
        });
      }
    } finally {
      setLoading(false);
    }
  };

  //   useEffect(() => {
  //     if (submissionData) {
  //       setFormData((prev) => ({ ...prev, ...submissionData }));
  //     }
  //   }, [submissionData]);

  //   useEffect(() => {
  //     console.log("🚀 ~ FillForm ~ form:", form);
  //     if (!form?.id || !meData?.user_id) return;

  //     const fetchSubmission = async () => {

  //     };

  //     fetchSubmission();
  //   }, [form, meData]);

  const renderPreviewField = (field) => {
    let value = submissionData?.[field.id];

    // ✅ Normalize values for special field types
    if (field.type === "checkbox" && typeof value === "string") {
      try {
        value = JSON.parse(value); // convert '["yes","no"]' → ["yes","no"]
      } catch (e) {
        value = [];
      }
    }

    if (field.type === "rating") {
      if (typeof value === "string") {
        value = parseInt(value, 10);
      }
      if (isNaN(value)) {
        value = 0; // fallback
      }
    }

    switch (field.type) {
      case "checkbox":
        return (
          <div key={field.id} className="form-field">
            <Label className="form-label">{field.label}</Label>
            <div className="form-radio-group">
              {field.options?.map((option, idx) => (
                <div
                  key={idx}
                  style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "6px" }}
                >
                  <Checkbox
                    id={`${field.id}-${idx}-preview`}
                    checked={Array.isArray(value) ? value.includes(option) : false}
                    disabled
                  />
                  <Label htmlFor={`${field.id}-${idx}-preview`} className="form-radio-item">
                    {option}
                  </Label>
                </div>
              ))}
            </div>
          </div>
        );

      case "radio":
        return (
          <div key={field.id} className="form-field">
            <Label className="form-label">{field.label}</Label>
            <RadioGroup value={value || ""} className="form-radio-group">
              {field.options?.map((option, idx) => (
                <div
                  key={idx}
                  style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "6px" }}
                >
                  <RadioGroupItem
                    value={option}
                    id={`${field.id}-${idx}-preview`}
                    checked={value === option}
                    disabled
                  />
                  <Label htmlFor={`${field.id}-${idx}-preview`} className="form-radio-item">
                    {option}
                  </Label>
                </div>
              ))}
            </RadioGroup>
          </div>
        );

      case "rating":
        return (
          <div key={field.id} className="form-field">
            <Label className="form-label">{field.label}</Label>
            <div className="form-rating">
              {[1, 2, 3, 4, 5].map((star) => (
                <button
                  key={star}
                  type="button"
                  className={`form-rating-star ${star <= value ? "active" : ""}`}
                  style={{
                    opacity: 0.9,
                    color: star <= value ? "#3b82f6" : "#d1d5db", // ✅ blue filled, gray empty
                    pointerEvents: "none",
                  }}
                >
                  <Star />
                </button>
              ))}
            </div>
          </div>
        );

      default:
        return (
          <div key={field.id} className="form-field">
            <Label className="form-label">{field.label}</Label>
            <Input
              value={value || ""}
              readOnly
              disabled
              className="form-input bg-gray-100 cursor-not-allowed"
            />
          </div>
        );
    }
  };

  const validateField = (field, value) => {
    if (field.required && (!value || (Array.isArray(value) && value.length === 0))) {
      return `${field.label} is required`;
    }

    if (field.validation) {
      if (field.validation.minLength && value && value.length < field.validation.minLength) {
        return `${field.label} must be at least ${field.validation.minLength} characters`;
      }
      if (field.validation.maxLength && value && value.length > field.validation.maxLength) {
        return `${field.label} must be no more than ${field.validation.maxLength} characters`;
      }
    }

    if (field.type === "email" && value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      return "Please enter a valid email address";
    }

    if (field.type === "phone" && value && !/^[+]?[1-9][\d]{0,9}$/.test(value.replace(/\s/g, ""))) {
      return "Please enter a valid phone number";
    }

    return null;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const newErrors = {};

    form.fields.forEach((field) => {
      const value = field.type === "rating" ? rating[field.id] : formData && formData[field.id];
      const error = validateField(field, value);
      if (error) {
        newErrors[field.id] = error;
      }
    });

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      const submissionData = {
        ...formData,
        ...rating,
        submittedAt: new Date().toISOString(),
      };
      handleFormSubmission(form.id, submissionData);
    }
  };

  const updateFormData = (fieldId, value) => {
    setFormData((prev) => ({ ...prev, [fieldId]: value }));
    if (errors[fieldId]) {
      setErrors((prev) => ({ ...prev, [fieldId]: "" }));
    }
  };

  const renderField = (field) => {
    // console.log("🚀 ~ renderField ~ field:", field)
    // console.log("🚀 ~ renderField ~ formData:", formData)
    const error = errors[field.id];

    switch (field.type) {
      case "textarea":
        return (
          <div key={field.id} className="form-field">
            <Label htmlFor={field.id} className="form-label">
              {field.label}
              {field.required && <span style={{ color: "red" }}>*</span>}
            </Label>
            <Textarea
              id={field.id}
              placeholder={field.placeholder}
              value={(formData && formData[field.id]) || ""}
              onChange={(e) => updateFormData(field.id, e.target.value)}
              className={`form-input ${error ? "border-destructive" : ""}`}
            />
            {error && <p className="form-error">{error}</p>}
          </div>
        );

      case "select":
        return (
          <div key={field.id} className="form-field">
            <Label htmlFor={field.id} className="form-label">
              {field.label}
              {field.required && <span style={{ color: "red" }}>*</span>}
            </Label>
            <Select
              value={(formData && formData && formData[field.id]) || ""}
              onValueChange={(value) => updateFormData(field.id, value)}
            >
              <SelectTrigger className={`form-select ${error ? "border-destructive" : ""}`}>
                <SelectValue placeholder={field.placeholder || "Select an option"} />
              </SelectTrigger>
              <SelectContent className="form-select-dropdown">
                {field.options?.map((option, index) => (
                  <SelectItem key={index} value={option} className="form-select-item">
                    {option}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            {error && <p className="form-error">{error}</p>}
          </div>
        );

      case "radio":
        return (
          <div key={field.id} className="form-field">
            <Label className="form-label">
              {field.label}
              {field.required && <span style={{ color: "red" }}>*</span>}
            </Label>
            <RadioGroup
              value={(formData && formData[field.id]) || ""}
              onValueChange={(value) => updateFormData(field.id, value)}
              className={`form-radio-group ${error ? "error" : ""}`}
            >
              {field.options?.map((option, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    marginBottom: "6px", // spacing between each option
                    minHeight: "28px", // makes row slightly taller
                  }}
                >
                  <RadioGroupItem value={option} id={`${field.id}-${index}`} />
                  <Label htmlFor={`${field.id}-${index}`} className="form-radio-item">
                    {option}
                  </Label>
                </div>
              ))}
            </RadioGroup>
            {error && <p className="form-error">{error}</p>}
          </div>
        );

      case "checkbox":
        return (
          <div key={field.id} className="form-field">
            <Label className="form-label">
              {field.label}
              {field.required && <span style={{ color: "red" }}>*</span>}
            </Label>
            <div className={`form-radio-group ${error ? "error" : ""}`}>
              {field.options?.map((option, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    marginBottom: "6px", // spacing between each option
                    minHeight: "28px", // makes row slightly taller
                  }}
                >
                  <Checkbox
                    id={`${field.id}-${index}`}
                    checked={((formData && formData[field.id]) || []).includes(option)}
                    onCheckedChange={(checked) => {
                      const currentValues = (formData && formData[field.id]) || [];
                      if (checked) {
                        updateFormData(field.id, [...currentValues, option]);
                      } else {
                        updateFormData(
                          field.id,
                          currentValues.filter((v) => v !== option)
                        );
                      }
                    }}
                  />
                  <Label htmlFor={`${field.id}-${index}`} className="form-radio-item">
                    {option}
                  </Label>
                </div>
              ))}
            </div>
            {error && <p className="form-error">{error}</p>}
          </div>
        );

      case "rating":
        return (
          <div key={field.id} className="form-field">
            <Label className="form-label">
              {field.label}
              {field.required && <span style={{ color: "red" }}>*</span>}
            </Label>
            <div className={`form-rating ${error ? "form-rating-error" : ""}`}>
              {[1, 2, 3, 4, 5].map((star) => (
                <button
                  key={star}
                  type="button"
                  onClick={() => setRating((prev) => ({ ...prev, [field.id]: star }))}
                  className={`form-rating-star ${star <= (rating[field.id] || 0) ? "active" : ""}`}
                >
                  <Star />
                </button>
              ))}
            </div>
            {error && <p className="form-error">{error}</p>}
          </div>
        );

      default:
        return (
          <div key={field.id} className="form-field">
            <Label htmlFor={field.id} className="form-label">
              {field.label}
              {field.required && <span style={{ color: "red" }}>*</span>}
            </Label>
            <Input
              id={field.id}
              type={field.type}
              placeholder={field.placeholder}
              value={(formData && formData[field.id]) || ""}
              onChange={(e) => updateFormData(field.id, e.target.value)}
              className={`form-input ${error ? "border-destructive" : ""}`}
            />
            {error && <p className="form-error">{error}</p>}
          </div>
        );
    }
  };
  const handleClose = () => setState({ ...state, open: false });
  return (
    <DashboardLayout>
      <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={state.open}
        autoHideDuration={4000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={handleClose} severity={state.severity} variant="filled">
          {state.message}
        </Alert>
      </Snackbar>
      <div>
        <div className="flex-between" style={{ marginBottom: "1rem" }}>
          <Button
            className="btn btn-outline"
            variant="outline"
            onClick={() => {
              if (meData?.role_id === 3) {
                navigate("/tasks-management");
              } else {
                navigate("/mission-tracker/" + formIDAndTitle);
              }
            }}
          >
            ← Back to Forms
          </Button>
        </div>
      </div>
      <div className="split-screen">
        {submissionData && Object.keys(submissionData).length > 0 && (
          <Card className="form-renderer-card">
            <CardHeader className="form-renderer-header">
              <CardTitle className="form-renderer-title">Your Previous Submission</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="space-y-6">{form.fields.map(renderPreviewField)}</div>
            </CardContent>
          </Card>
        )}
        {!submissionData && (
          <Card className="form-renderer-card">
            <CardHeader className="form-renderer-header">
              <CardTitle className="form-renderer-title">
                {formIDAndTitle && formIDAndTitle.includes("--")
                  ? formIDAndTitle.split("--")[1].replaceAll("-", " ")
                  : ""}
              </CardTitle>
            </CardHeader>
            <CardContent>
              <form onSubmit={handleSubmit} className="space-y-6">
                {form && form.fields.map(renderField)}

                <div style={{ display: "flex", justifyContent: "center" }}>
                  <Button
                    type="submit"
                    disabled={loading}
                    style={{
                      backgroundColor: "green",
                      color: "white",
                      padding: "8px 16px",
                      borderRadius: "6px",
                      border: "none",
                      cursor: "pointer",
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "darkgreen")}
                    onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "green")}
                  >
                    Submit Form
                  </Button>
                </div>
              </form>
            </CardContent>
          </Card>
        )}
      </div>
    </DashboardLayout>
  );
}
